<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>{{ 'User.Users' | translate }}</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['']">Home</a></li>
                    <li class="breadcrumb-item active"><a [routerLink]="['/user-all']">{{ 'User.User' | translate }}</a>
                    </li>
                </ol>
            </div>
        </div>
    </div>
    <!-- /.container-fluid -->
</section>

<div class="container">
    <div class="container-fluid">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">

                    <div class="position-relative mb-4">
                        <!-- <div class="chartjs-size-monitor">
                                <div class="chartjs-size-monitor-expand">
                                    <div class=""></div>
                                </div>
                                <div class="chartjs-size-monitor-shrink">
                                    <div class=""></div>
                                </div>
                            </div> -->
                        <div class="col-sm-12">
                            <img style="height:400px; margin-left:40%" class="img-fluid" src="{{user?.avatar}}"
                                alt="photo">
                        </div>

                    </div>

                </div>
            </div>

        </div>
        <div class="row">

            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header border-0">
                        <h3 class="card-title">Information personnel</h3>

                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-striped table-valign-middle">
                            <tbody>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.nameLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.name}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.emailLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.email}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.CNI_numberLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.CNI_number}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.picture_CNILabel" | translate }}</td>
                                    <td><a href="{{user?.picture_CNI}}">Parcourir</a></td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.sexeLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.sexe}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.birth_dateLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.birth_date}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.birth_placeLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.birth_place}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.phone_number_1Label" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.phone_number_1}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.phone_number_2Label" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.phone_number_2}}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header border-0">
                        <h3 class="card-title">Information personnel</h3>

                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-striped table-valign-middle">
                            <tbody>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.marital_statusrLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.marital_status}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.childrenLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.children}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.residence_townLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.residence_town}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.contact_personLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.contact_person}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.emergency_phoneLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.emergency_phone}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Chauffeur.adressLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{user?.adress}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>


                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <!-- /.col-md-6 -->
        </div>

    </div>
    <!-- /.container-fluid -->
</div>